module.exports = __webpack_public_path__ + "assets/GTAmerica-ExpandedRegular.ttf";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExpandedRegular.ttf
// module id = 1003
// module chunks = 19